import Turbolinks from "turbolinks"

const PageNavigation = {
  clearCache() {
    Turbolinks.clearCache()
  },

  isPreview() {
    return document.documentElement.hasAttribute("data-turbolinks-preview")
  },

  visit(location, options) {
    Turbolinks.visit(location, options)
  },
}

export { PageNavigation }
